import {Component} from 'panel';

import {registerMPElement} from 'common/util/register-element';

import {generateMessage} from '../utils/message/';

import template from './index.jade';

class SmartHubSummary extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'utc-offset': `number`,
    };
  }

  get config() {
    return {
      template,
    };
  }

  get alert() {
    return this.app.getAlert();
  }

  get message() {
    // Smart hub v2 will only appear in a report, not in the global dropdown
    return generateMessage(this.alert.raw, {
      displayContext: `IN_REPORT`,
      subContext: `SUMMARY`,
      utcOffset: parseInt(this.attr(`utc-offset`)),
    });
  }
}

export default registerMPElement(`mp-smart-hub-summary`, SmartHubSummary);
